import { useMakeIsGranted } from './useMakeIsGranted'

export const useIsGranted = (...args: Parameters<ReturnType<typeof useMakeIsGranted>['isGranted']>) => {
  const { isGranted } = useMakeIsGranted()
  return isGranted(...args)
}
